import { render } from "./Configure.vue?vue&type=template&id=18f1593e"
import script from "./Configure.vue?vue&type=script&lang=js"
export * from "./Configure.vue?vue&type=script&lang=js"

import "./Configure.vue?vue&type=style&index=0&id=18f1593e&scope=true&lang=scss"
script.render = render

export default script